import { combineEpics } from 'redux-observable';

import { route } from 'modules/mac/duck/actions/updateCreditCard';

import { timeAction, counter } from './util';

export default combineEpics(
  counter(route.type, 'mac.update-credit-card'),
  timeAction(route.type, 'mac.update-credit-card'),
);
